module.exports = __webpack_public_path__ + "img/thumbnail_TimberWolf_f_normal.72f28326.png";